(function(){
  if(window.nuvantaRoundedHeaderVersion!=='6'){
    window.nuvantaRoundedHeader=function(scope){
      var roots=scope.matches&&scope.matches('[data-nv-header]')?[scope]:scope.querySelectorAll('[data-nv-header]');
      roots.forEach(function(root){
        if(root.dataset.nvReady==='6')return;
        if(root.nvDisconnect)root.nvDisconnect();
        root.dataset.nvReady='6';
        var controller=new AbortController();
        var lang=document.documentElement.lang.indexOf('en')===0?'en':'es';
        var languageButton=root.querySelector('.nvh-language');
        var menu=root.querySelector('details');
        var spacer=root.previousElementSibling;
        var atTop=window.scrollY<=24;
        var frame=0;
        function sizeSpacer(){if(spacer&&spacer.hasAttribute('data-nv-header-spacer'))spacer.style.height=root.getBoundingClientRect().height+'px'}
        function refreshScroll(){
          frame=0;
          if(!root.isConnected)return;
          if(atTop&&window.scrollY>64)atTop=false;
          else if(!atTop&&window.scrollY<=24)atTop=true;
          root.classList.toggle('nvh-at-top',atTop);
        }
        function onScroll(){if(!frame)frame=requestAnimationFrame(refreshScroll)}
        refreshScroll();
        sizeSpacer();
        window.addEventListener('scroll',onScroll,{passive:true,signal:controller.signal});
        window.addEventListener('resize',sizeSpacer,{passive:true,signal:controller.signal});
        var sizeObserver=typeof ResizeObserver==='function'?new ResizeObserver(sizeSpacer):null;
        if(sizeObserver)sizeObserver.observe(root);
        function update(next){
          lang=next;
          root.querySelectorAll('[data-nv-es]').forEach(function(el){el.textContent=el.getAttribute('data-nv-'+lang)});
          languageButton.innerHTML=lang==='es'?'ES <span>/ EN</span>':'EN <span>/ ES</span>';
          languageButton.setAttribute('aria-label',lang==='es'?'Cambiar idioma a inglés':'Change language to Spanish');
        }
        update(lang);
        languageButton.addEventListener('click',function(){
          var next=lang==='es'?'en':'es';
          var nativeButton=Array.from(document.querySelectorAll('#nuvanta-root .language')).find(function(el){return !root.contains(el)});
          if(nativeButton){
            if(document.documentElement.lang!==next)nativeButton.click();
          }else{
            document.documentElement.lang=next;
            document.querySelectorAll('[data-en][data-es]').forEach(function(el){el.innerHTML=el.dataset[next]});
            try{localStorage.setItem('nuvanta-language',next)}catch(e){}
          }
          update(next);
        });
        root.querySelectorAll('a').forEach(function(link){
          link.addEventListener('click',function(){menu.open=false},{signal:controller.signal});
          if(link.getAttribute('href')===window.location.pathname)link.setAttribute('aria-current','page');
        });
        root.addEventListener('keydown',function(event){if(event.key==='Escape'){menu.open=false;root.querySelector('summary').focus()}});
        var observer=new MutationObserver(function(){update(document.documentElement.lang.indexOf('en')===0?'en':'es')});
        observer.observe(document.documentElement,{attributes:true,attributeFilter:['lang']});
        root.nvDisconnect=function(){controller.abort();observer.disconnect();if(sizeObserver)sizeObserver.disconnect();window.removeEventListener('scroll',onScroll);window.removeEventListener('resize',sizeSpacer);if(frame)cancelAnimationFrame(frame)};
      });
    };
    window.nuvantaRoundedHeaderVersion='6';
    document.addEventListener('shopify:section:load',function(event){window.nuvantaRoundedHeader(event.target)});
    document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('[data-nv-header]').forEach(function(root){if(root.nvDisconnect)root.nvDisconnect()})});
  }
  window.nuvantaRoundedHeader(document);
})();
;
(function(){
  function init(root){
    var blocks=root.querySelectorAll('.nvpro-visible');

    blocks.forEach(function(block){
      if(block.dataset.nvproReady)return;
      block.dataset.nvproReady='true';

      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;

      var items=block.querySelectorAll('.nvpro-steps li');

      function enter(){
        if(!block.isConnected)return;

        block.querySelector('.nvpro-steps').classList.add('nvpro-enter');

        if(typeof block.animate!=='function')return;

        block.querySelector('h2').animate([
          {transform:'translateY(16px)',opacity:.65},
          {transform:'translateY(0)',opacity:1}
        ],{
          duration:850,
          easing:'cubic-bezier(.16,1,.3,1)'
        });

        items.forEach(function(item,index){
          item.animate([
            {transform:'translateY(24px)',opacity:.45},
            {transform:'translateY(0)',opacity:1}
          ],{
            duration:900,
            delay:140+index*140,
            easing:'cubic-bezier(.16,1,.3,1)'
          });
        });
      }

      if(!('IntersectionObserver' in window)){
        enter();
        return;
      }

      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            observer.disconnect();
            enter();
          }
        });
      },{threshold:.12});

      observer.observe(block);
    });
  }

  if(window.nvproInit){
    window.nvproInit(document);
    return;
  }

  window.nvproInit=init;
  init(document);

  document.addEventListener('shopify:section:load',function(event){
    init(event.target);
  });
})();
;
(function(){
  function init(root){
    root.querySelectorAll('.nvfaq__item').forEach(function(item){
      if(item.dataset.nvfaqReady)return;
      item.dataset.nvfaqReady='true';

      var summary=item.querySelector('summary');
      var state=null;

      summary.addEventListener('click',function(event){
        if(
          window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
          typeof item.animate!=='function'
        )return;

        event.preventDefault();

        var nextOpen=!(state?state.open:item.open);
        var from=item.getBoundingClientRect().height;

        if(state)state.animation.cancel();

        item.open=true;
        item.style.height='auto';

        var to=nextOpen
          ? item.getBoundingClientRect().height
          : summary.getBoundingClientRect().height+1;

        item.style.height=from+'px';
        item.style.overflow='hidden';

        var animation=item.animate([
          {height:from+'px'},
          {height:to+'px'}
        ],{
          duration:400,
          easing:'cubic-bezier(.22,1,.36,1)',
          fill:'both'
        });

        state={
          animation:animation,
          open:nextOpen
        };

        animation.onfinish=function(){
          if(!state||state.animation!==animation)return;

          item.open=nextOpen;
          item.style.removeProperty('height');
          item.style.removeProperty('overflow');
          animation.cancel();
          state=null;
        };
      });
    });
  }

  if(window.nvfaqInit){
    window.nvfaqInit(document);
    return;
  }

  window.nvfaqInit=init;
  init(document);

  document.addEventListener('shopify:section:load',function(event){
    init(event.target);
  });
})();